import {dataMember, required, typedArray} from 'santee-dcts';
import * as moment from 'moment';
import {deserializers} from '../../core';
import {EQuerySubmittedResponseAttachment} from './e-query-submitted-response-attachment';

export class EQuerySubmittedResponse {
    @dataMember()
    @required()
    public responseId: number;

    @dataMember()
    @required()
    public questionId: number;

    @dataMember()
    @required({nullable: true})
    public responseText: string;

    @dataMember()
    @required()
    public createdUserName: string;

    @dataMember()
    @required()
    public createdUserRoles: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required()
    public createdDateTime: moment.Moment;

    @dataMember()
    @required({nullable: true})
    @typedArray(EQuerySubmittedResponseAttachment)
    public responseAttachments: EQuerySubmittedResponseAttachment[];
}